import React, { useEffect, useRef, useState } from "react"
import RedSodaLoading from "./redsoda-loading"

const TIMEOUT_IFRAME_LOAD = 4000

const QuoteSection = ({ title = "quote-section", src, ...props }) => {
  const [isLoading, setIsLoading] = useState(true)
  const iframeRef = useRef(null)
  const [sizeLoading, setSizeLoading] = useState(null)

  const srcURL = new URL(src)
  srcURL.searchParams.append("t", Date.now())

  useEffect(() => {
    setSizeLoading({
      width: iframeRef.current.clientWidth,
      height: iframeRef.current.clientHeight,
    })

    iframeRef.current.onload = () => setIsLoading(false)

    setTimeout(() => {
      setIsLoading(false)
    }, TIMEOUT_IFRAME_LOAD)
  }, [])

  return (
    <>
      {sizeLoading && isLoading && <RedSodaLoading style={sizeLoading} />}
      <iframe ref={iframeRef} title={title} src={srcURL} {...props} />
    </>
  )
}

export default QuoteSection
